/**
 * This file is auto-generated from formatProductPrice.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const perMonth = lang => {
    switch (lang) {
        case 'en':
            return '/month';
        case 'pl':
            return '/mies.';
    }
};
//# sourceMappingURL=formatProductPrice.loc.js.map